/* Package JSON Import will be here */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import cartIcon from "assets/img/cart.png";
import logo from "assets/img/logo-icon.png";
import SearchProducts from "./SearchProducts";
import { appRoutesConst } from "app/navigation";
/* Project Import will be here */

class MobileCategoryMenu extends Component {
  renderMobileNav = () => {
    const { notifications, cart, appSettings, retailer, router, translate } = this.props;
    let path = router.location.pathname;

    return (
      <nav className="navbar mobile-nav navbar-expand-lg nav-sm pd-l-r-5">
        <div className="d-flex flex-row align-items-center justify-content-between pd-0-15">
          {(path !== appRoutesConst.orderSummary) &&
            <div className="nav-link nav-link-drawer-menu-padding mt-1 ">
              <i onClick={this.props.openDrawerMenu} className="fa fa-bars fa-lg fav-product-header-icon cursor-pointer" aria-hidden="true"></i>
            </div>
          }

          <div className="d-flex align-items-center mobile-logo-block">
            <Link className={"navbar-brand " + (path === appRoutesConst.orderSummary && 'hide-slug')} to={appSettings.isEnableHomePage ? appRoutesConst.home : appRoutesConst.productList}>
              <span className="logo--icon">
                <img src={logo} alt="" />
              </span>
              <span className="logo-name">{translate("common.ivyMarketplace")}</span>
            </Link>

            {/* Client logo */}
            {window.clientLogoUrl !== "" ?
              <img className="client-image-height" src={window.clientLogoUrl} alt={translate("common.imageAlt.clientLogo")} />
              :
              <h5 className="header-title-text">{retailer.retailername}</h5>
            }

          </div>
          <div>
            {(path !== appRoutesConst.orderSummary) &&
              <ul className="navbar-nav flex-row justify-content-end align-items-center">
                {/* Favourite product heart icon */}
                {(appSettings.isFavProductEnable) &&
                  <li className="nav-item mt-1">
                    <Link to={appRoutesConst.favProducts} className="nav-link">
                      <i className="fa fa-heart fa-lg" aria-hidden="true"></i>
                    </Link>
                  </li>
                }

                {(appSettings.isShowNotifications) &&
                  <li className="nav-item cart__link--content mt-1">
                    <Link to={appRoutesConst.notification} className="nav-link">
                      <React.Fragment>
                        <i className="fa fa-bell fa-lg" aria-hidden="true"></i>

                        <div className="random--text">
                          <p>{notifications.count}</p>
                        </div>
                      </React.Fragment>
                    </Link>
                  </li>
                }

                <li className="nav-item cart__link--content">
                  <Link to={appRoutesConst.orderSummary} className="nav-link">
                    <React.Fragment>
                      <img src={cartIcon} alt="Cart" />

                      <div className="random--text">
                        <p>{(cart.ids.length + cart.freeProducts.length) || 0} </p>
                      </div>
                    </React.Fragment>
                  </Link>
                </li>
              </ul>
            }
          </div>
          {(path !== appRoutesConst.orderSummary) &&
            <SearchProducts />
          }
        </div>
      </nav>
    );
  };

  render() {
    return this.renderMobileNav();
  }
}

const mapStateToProps = (state) => ({
  notifications: state.notifications,
  cart: state.cart,
  router: state.router,
  appSettings: state.appSettings,
  retailer: state.localStore.user,
  translate: getTranslate(state.locale),
});

export default connect(mapStateToProps, null)(MobileCategoryMenu);